export default __webpack_public_path__ + "static/BanImg6-cf1f55195f060207cad3fb434e8e8f31.webp";